import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {

  private currentVersion = '';

  constructor() { }

  public checkVersion() {
    const timestamp = new Date().getTime();
    fetch(`/index.html?v=${timestamp}`, { cache: 'no-store' })
      .then(response => response.text())
      .then(html => {
        if (!this.currentVersion) {
          this.currentVersion = html;
        } else if (this.currentVersion !== html) {
          // Página mudou, recarrega
          console.log('Nova versão detectada! Recarregando...');
          window.location.reload();
        }
      })
      .catch(error => {
        console.warn('Erro ao verificar versão:', error);
      });
  }
}